import { AsyncReturnType } from "type-fest";

import { BillingService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof BillingService.deletePaymentMethod>[0];
type Data = AsyncReturnType<typeof BillingService.deletePaymentMethod>;
type Error = unknown;

export const useDeletePaymentMethod = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    BillingService.deletePaymentMethod,
    options
  );

  return result;
};
